import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { AiOutlineCaretRight } from "react-icons/ai";
import { leaf, mainLeaf } from "../../assets";
import { motion } from "framer-motion";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Accesories = () => {
  const gridDiv = useRef();

  const handleActive = (e) => {
    const childrens = Array.from(gridDiv.current.querySelectorAll(".grid"));

    console.log(childrens);

    let class_name = e.target.className;
    console.log(class_name);

    if (!class_name.includes("gridActive")) {
      childrens.map((c) => {
        if (c.className.includes("gridActive")) {
          c.className = "grid";
        }
        return null;
      });

      e.target.className = "grid gridActive";
    }
  };
  return (
    <motion.div
      id="accesories"
      whileInView={{ y: [50, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
    >
      <div className="mainContent">
        <div className="leftSec">
          <LazyLoadImage effect="blur" src={mainLeaf} alt="" className="leftLeaf" />
          <LazyLoadImage effect="blur" src={mainLeaf} alt="" className="rightLeaf" />
          <p className="intro">Treatment Equipments</p>
          <h1>Helping You Achieve Your Goals</h1>
          <p className="proud">
            We are very proud of all the results we achieved with this products
          </p>

          <p className="desc">
            Beauty treatment equipment consists of various tools and devices
            used in the beauty industry to enhance appearance. These tools
            include lasers, microdermabrasion machines, and more, offering
            treatments like skin rejuvenation and hair removal for effective and
            safe beauty enhancement.
          </p>

          <Link to="/all-equipments" className="moreTools">
            Discover More <AiOutlineCaretRight className="ico" />
          </Link>
        </div>
        <div className="rightSec" ref={gridDiv}>
          <div className={`grid gridActive`} onClick={handleActive}>
            <div className="details">
              <LazyLoadImage effect="blur" src={leaf} alt="" />
              <h1>Zerona®</h1>
              <p>
                Zerona is a non-invasive body contouring treatment that uses low
                level laser energy to reduce the size of stubborn fat deposits
                on the waist, hips, and thighs.
              </p>
            </div>
          </div>
          <div className={`grid`} onClick={handleActive}>
            <div className="details">
              <LazyLoadImage effect="blur" src={leaf} alt="" />
              <h1>Candela®</h1>
              <p>
                It is a dual wavelength laser for high performance treatment
                capabilities in terms of speed, efficacy, ease-of-use,
                performance, safety and patient satisfaction.
              </p>
            </div>
          </div>
          <div className={`grid`} onClick={handleActive}>
            <div className="details">
              <LazyLoadImage effect="blur" src={leaf} alt="" />
              <h1>Coolsculpting®</h1>
              <p>
                It is a non-invasive fat reduction treatment that utilises
                cryolipolysis technology to remove unwanted fat cells by
                freezing them.
              </p>
            </div>
          </div>
          <div className={`grid`} onClick={handleActive}>
            <div className="details">
              <LazyLoadImage effect="blur" src={leaf} alt="" />
              <h1>Hydrafacial®</h1>
              <p>
                Hydrafacial machine delivers gentle cleansing and exfoliation
                that is good for oily and acne-prone skin & unclog pores and
                remove impurities from the surface of the skin.
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Accesories;
